import Select from "react-select";
import { SelectOption } from "../types";
import { reactSelectSMStyle, styles } from "Utils/Common";
import useLang from "Shared/hooks/useLanguage";

interface StepReagentSelectProps {
  reagentOptions: SelectOption[];
  selectedReagents: SelectOption[];
  onReagentChange: (value: SelectOption[]) => void;
  isDisabled?: boolean;
}

export function StepReagentSelect({
  reagentOptions,
  selectedReagents,
  onReagentChange,
  isDisabled = false,
}: StepReagentSelectProps) {
  const { t } = useLang();

  const selectedOptions = selectedReagents.map(
    (selected) =>
      reagentOptions.find((r) => String(r.value) === String(selected.value)) ||
      selected
  );

  return (
    <div className="mt-3">
      <label
        className="form-label mb-1 fw-500"
        style={{ fontSize: "13px", color: "#333" }}
      >
        {t("Please select reagents")}
      </label>
      <Select<SelectOption, true>
        theme={(theme) => styles(theme)}
        options={reagentOptions}
        value={selectedOptions}
        styles={{
          ...reactSelectSMStyle,
          control: (provided) => ({
            ...provided,
            minWidth: "100%",
            border: "1px solid #e5e5e5",
            borderRadius: "6px",
            "&:hover": {
              border: "1px solid #e5e5e5",
            },
          }),
        }}
        menuPortalTarget={document.body}
        placeholder={`--- ${t("Select")} ---`}
        isSearchable={true}
        isMulti
        isDisabled={isDisabled}
        closeMenuOnSelect={false}
        onChange={(opt) => {
          onReagentChange([...opt]);
        }}
      />
    </div>
  );
}
